import React from "react";

import DefaultImage from "../../../assets/images/default-avatar-photo-placeholder-profile-picture-vector.jpg";
import KathrynSorianoPosadas from "../../../assets/images/directors/kathryn-soriano-posadas.png";
import ReynatoPrimo from "../../../assets/images/directors/reynato-primo.png";

const CorporateGovernanceCommittee = () => {
  return (
    <div id='chartListContainer'>
      <ul className='main-list'>
        <div className='list-item main'>
          <div className='image-container'>
            <img src={DefaultImage} alt='' />
          </div>
          <div className='text-container'>
            <div className='name'>[Vacant Position]</div>
            <div className='title'>Chairman</div>
          </div>
        </div>
      </ul>
      <ul className='sub-list'>
        <li className='list-item'>
          <div className='image-container'>
            <img src={KathrynSorianoPosadas} alt='kathryn-soriano-posadas' />
          </div>
          <div className='text-container'>
            <div className='name'>Kathryn Leia S. Soriano-Posadas</div>
            <div className='title'>Member</div>
          </div>
        </li>
        <li className='list-item'>
          <div className='image-container'>
            <img src={ReynatoPrimo} alt='reynato-primo' />
          </div>
          <div className='text-container'>
            <div className='name'>Reynato J. Primo</div>
            <div className='title'>Member</div>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default CorporateGovernanceCommittee;
